// extracted by mini-css-extract-plugin
export default {"container":"player-stats_container__XQZW4","title":"player-stats_title__JIoVK"};